import React from "react";

const JitsiStudent = props => {
  const jitsiContainerId = "jitsi-container-id";
  const [jitsi, setJitsi] = React.useState({});

  const loadJitsiScript = () => {
    let resolveLoadJitsiScriptPromise = null;

    const loadJitsiScriptPromise = new Promise(resolve => {
      resolveLoadJitsiScriptPromise = resolve;
    });

    const script = document.createElement("script");
    script.src = "https://meet.jit.si/external_api.js";
    script.async = true;
    script.onload = () => resolveLoadJitsiScriptPromise(true);
    document.body.appendChild(script);

    return loadJitsiScriptPromise;
  };

  const initialiseJitsi = async () => {
    if (!window.JitsiMeetExternalAPI) {
      await loadJitsiScript();
    }

    let opcoes = {
      parentNode: document.getElementById(jitsiContainerId),
      roomName: props.room,

      interfaceConfigOverwrite: {
        SHOW_CHROME_EXTENSION_BANNER: false,
        APP_NAME: "Educandus",
        DEFAULT_LOGO_URL: "",
        JITSI_WATERMARK_LINK: "https://google.com",
        liveStreamingEnabled: false,
        TOOLBAR_BUTTONS: [
          "microphone",
          "camera",
          "fodeviceselection",
          "settings",
          "tileview",
          "fullscreen",
          "hangup",
          // "chat",
          "raisehand",
          "videoquality",
          "desktop"
        ]
      },

      configOverwrite: {
        prejoinPageEnabled: false,
        startWithAudioMuted: true,
        startWithVideoMuted: true,
        remoteVideoMenu: {
          disableKick: true
        },
        disableRemoteMute: true
      },
      userInfo: {
        displayName: props.user
      }
    };

    // onde a mágica acontece
    let _jitsi = new window.JitsiMeetExternalAPI("meet.jit.si", opcoes);

    props.onJitsi(_jitsi);

    setJitsi(_jitsi);
  };

  React.useEffect(() => {
    initialiseJitsi();

    return () => jitsi?.dispose?.();
  }, []);

  return (
    <div
      id={jitsiContainerId}
      style={props.style}
      className={props.className}
    />
  );
};

export default JitsiStudent;
